function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Checklist = function Checklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M7.115 17.938a1 1 0 0 1-.006 1.414l-2.713 2.69a1 1 0 0 1-.704.29h-.006a1 1 0 0 1-.707-.297l-1.447-1.47a.999.999 0 1 1 1.425-1.404l.743.755 2.001-1.985a1 1 0 0 1 1.414.006m14.9 1.049a1 1 0 0 1 0 2H10.917a1 1 0 0 1 0-2zM4.325 9.08a3.33 3.33 0 0 1 3.325 3.325 3.33 3.33 0 0 1-3.325 3.325A3.33 3.33 0 0 1 1 12.406a3.33 3.33 0 0 1 3.325-3.325m0 2c-.73 0-1.325.594-1.325 1.325s.595 1.325 1.325 1.325 1.325-.594 1.325-1.325-.595-1.325-1.325-1.325m17.69.325a1 1 0 0 1 0 2H10.917a1 1 0 0 1 0-2zM4.325 1.5A3.33 3.33 0 0 1 7.65 4.825 3.33 3.33 0 0 1 4.325 8.15 3.33 3.33 0 0 1 1 4.825 3.33 3.33 0 0 1 4.325 1.5m0 2C3.595 3.5 3 4.094 3 4.825S3.595 6.15 4.325 6.15 5.65 5.556 5.65 4.825 5.055 3.5 4.325 3.5m17.69.325a1 1 0 0 1 0 2H10.917a1 1 0 0 1 0-2z"
  }));
};
export default Checklist;